import { FrontendContextV1 } from "@made-people/nestjs-bff-service";
import axios from "axios";

/**
 * Creates an axios instance for the legacy backend service.
 */
export const createMmBackendClient = (frontendContext: FrontendContextV1) => {
  const params = {
    market: frontendContext.market,
    country: frontendContext.country,
    language: frontendContext.language,
    pricelist: frontendContext.pricelist,
  };

  let baseURL;
  if (typeof window !== "undefined") {
    switch (true) {
      case window.location.hostname.includes("miss-mary-891303671566"):
        baseURL = "https://www.missmary.com/backend";
        break;
      case window.location.hostname.includes("staging"):
        baseURL = "https://staging2-www.missmary.fr/backend";
        break;
      case window.location.hostname.includes("localhost"):
      case /miss-mary-.+run\.app/.test(window.location.hostname):
        baseURL =
          "https://mm-frontend-24579420-review-main-yi2y9f.frackend.net/backend";
        break;
      default:
        // All production domains must be used for baseURL. Without this, the
        // x-ga cookie will not persist as it's SameSite=Lax.
        baseURL = new URL("backend", window.location.origin).toString();
        break;
    }
  }

  return axios.create({
    baseURL,
    params,
  });
};
